import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";

export const TiersTable = ({ config }) => {
  const { t } = useTranslation();
  if (!config) return null;
  const cur = (config.currency || "usd").toUpperCase();

  return (
    <NeuCard className="p-6" data-testid="tiers-table">
      <h2 className="text-base font-black md:text-lg">{t("pricingPage.tiers")}</h2>
      <div className="mt-4 grid gap-2">
        {config.tiers.map((tier) => (
          <div
            key={tier.min_employees}
            className="neu-in flex items-center justify-between rounded-2xl px-4 py-3"
            data-testid={`tier-${tier.min_employees}`}
          >
            <p className="text-sm font-semibold">
              {tier.min_employees} – {tier.max_employees ?? "∞"} {t("pricingPage.employeesShort")}
            </p>
            <p className="font-mono text-sm font-bold text-primary">
              {tier.price_per_employee} {cur} {t("billing.perEmployee")}
            </p>
          </div>
        ))}
      </div>
      <p className="mt-4 text-xs text-muted-foreground">
        {t("pricingPage.branchNote", {
          included: config.included_branches ?? 0,
          price: config.price_per_branch ?? 0,
          currency: cur,
        })}
      </p>
    </NeuCard>
  );
};
